<template>
  <div v-if="currentBudget">
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Gestion des budgets'"
          :description="'Aperçu d\'un budget'"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push({ name: 'budget' }).catch(() => {})"
        >
          Liste des budgets
        </button>

        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'budget-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouveau budget
        </button>

        <button
          v-if="currentBudget.statut === 0"
          type="button"
          class="btn btn-custom-primary"
          style="min-width: 100px"
          @click.prevent="
            $router
              .push({
                name: 'budget-edit',
                params: { id: id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>

      <div class="col-md-12 col-lg-6">
        <b-button
          variant="success"
          class="btn-icon mr-4"
          @click="valider"
          v-if="currentBudget.statut === 0"
        >
          <span class="btn-icon-label">
            <i class="fas fa-thumbs-up"></i>
          </span>
          Valider
        </b-button>
        <b-button
          variant="danger"
          class="btn-icon mr-4"
          @click="refuser"
          v-if="currentBudget.statut === 0"
        >
          <span class="btn-icon-label">
            <i class="fas fa-thumbs-down"></i>
          </span>
          Réfuser
        </b-button>
        <b-button variant="warning" class="btn-icon" @click="reinitialiser">
          <span class="btn-icon-label">
            <i class="fas fa-times"></i>
          </span>
          Réinitialiser
        </b-button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Année</span>
                  </td>
                  <td>
                    {{ currentBudget.annee }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Centre de coût</span>
                  </td>
                  <td>
                    {{ currentBudget.centre_cout.nom }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Version</span>
                  </td>
                  <td>
                    {{ currentBudget.version }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Statut</span>
                  </td>
                  <td>
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="{
                        'text-warning': currentBudget.statut === 0,
                        'text-success': currentBudget.statut === 1,
                        'text-danger': currentBudget.statut === 2,
                      }"
                    ></i>
                    {{ getStatutBudget(currentBudget.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-12 zui-wrapper">
          <div class="zui-scroll">
            <table
              class="card table table-sm table-striped table-condensed zui-table"
            >
              <thead>
                <tr>
                  <th style="width: 400px">Lignes budgétairess</th>
                  <th class="text-center" style="width: 150px">Janvier</th>
                  <th class="text-center" style="width: 150px">Février</th>
                  <th class="text-center" style="width: 150px">Mars</th>
                  <th class="text-center" style="width: 150px">Avril</th>
                  <th class="text-center" style="width: 150px">Mai</th>
                  <th class="text-center" style="width: 150px">Juin</th>
                  <th class="text-center" style="width: 150px">Juillet</th>
                  <th class="text-center" style="width: 150px">Août</th>
                  <th class="text-center" style="width: 150px">Septembre</th>
                  <th class="text-center" style="width: 150px">Octobre</th>
                  <th class="text-center" style="width: 150px">Novembre</th>
                  <th class="text-center" style="width: 150px">Décembre</th>
                  <th class="text-center" style="width: 300px">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in currentBudget.item_lists"
                  :key="index"
                >
                  <td style="vertical-align: middle; width: 400px">
                    {{ item.nom }}
                  </td>

                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p1"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>

                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p2"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>

                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p3"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>

                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p4"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p5"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p6"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p7"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p8"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p9"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p10"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p11"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-center"
                    style="vertical-align: middle; width: 150px"
                  >
                    <input
                      class="form-control"
                      v-model.number="item.p12"
                      type="text"
                      placeholder="Montant"
                      disabled
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    style="vertical-align: middle; width: 300px"
                  >
                    {{ total(item) | currency }}
                  </td>
                </tr>
                <tr
                  v-if="currentBudget.item_lists.length > 0"
                  class="d-flex font-size-17"
                >
                  <td
                    colspan="13"
                    class="text-center font-weight-bold"
                    style="width: 2200px"
                  >
                    TOTAL
                  </td>
                  <td class="text-right font-weight-bold" style="width: 300px">
                    {{ gTotal() | currency }}
                  </td>
                </tr>
                <tr v-if="currentBudget.item_lists.length === 0" class="d-flex">
                  <td colspan="14" class="text-center">Aucune donnée</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/achat/budget';
export default {
  data() {
    return {
      currentBudget: null,
      title: 'Gestion des budgets - Aperçu',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    valider() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.VALIDER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    refuser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REFUSER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    reinitialiser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REINITIALISER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    gTotal() {
      let total = 0;
      this.currentBudget.item_lists.map((item) => {
        total += this.total(item);
      });
      return total;
    },

    total(item) {
      return (
        Number(item.p1) +
        Number(item.p2) +
        Number(item.p3) +
        Number(item.p4) +
        Number(item.p5) +
        Number(item.p6) +
        Number(item.p7) +
        Number(item.p8) +
        Number(item.p9) +
        Number(item.p10) +
        Number(item.p11) +
        Number(item.p12)
      );
    },
    init() {
      this.id = this.$route.params.id;
      window.axios
        .get(URL.BUDGET + '/' + this.id)
        .then((resp) => {
          this.currentBudget = resp.data.budget;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.zui-wrapper {
  position: relative;
}
.zui-scroll {
  overflow-x: scroll;
  overflow-y: visible;
  padding-bottom: 5px;
}
.zui-table {
  left: 0;
  top: auto;
  width: 2400px;
}
</style>
